/*=============================================== HrPage ===============================================*/

import { Hr } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType } from "components"

const HrPage = () => {
    const items: ItemType[] = [
        {
            content: <Hr />,
            code: "<Hr />",
        },
    ]

    return <ComponentsLayout items={items} propsItems={[]} />
}

export default HrPage
